// DisablePlugin.tsx
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot } from "lexical";
import { useEffect } from "react";

type Props = { disabled: boolean; };

export function DisablePlugin({ disabled }: Props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // disabled=true → read-only, false → edit モード
    editor.setEditable(!disabled); // コンテンツ編集の有効/無効を切り替え

    // 2. disabled 時は内容をクリアして空段落を追加
    if (disabled) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        root.append($createParagraphNode());
      });
    }

    // 3. 見た目の切り替え（CSS クラスを付与／削除）
    const rootElement = editor.getRootElement(); // ContentEditable の DOM ノード
    if (rootElement) {
      rootElement.classList.toggle("editor--disabled", disabled);
    }
  }, [editor, disabled]);

  return null;
}
